<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px mr-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入考试名称"
          v-model="searchData.examName"
          clearable
        ></el-input>
        <!-- <el-date-picker
          class="mr-10px mb-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker> -->
        <el-date-picker
          v-model="searchData.singleExamStartTime"
          form
          type="date"
          size="small"
          class="mr-10px !w-50 mb-10px"
          :placeholder="`${$t('开始日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          v-model="searchData.singleExamEndTime"
          type="date"
          size="small"
          class="mr-10px !w-50 mb-10px"
          :placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          v-model="searchData.makeUpExam"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择是否补考"
          clearable
        >
          <el-option
            v-for="item in makeUpExamList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button class="mb-10px" size="small" @click="resetSearch">重置</el-button>
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
          @selection-change="handleSelection"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="考试名称"
            prop="examName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="考试编码"
            prop="examCode"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="考试类型"
            width="140"
            prop="examCategoryStr"
            show-overflow-tooltip
          />
          <el-table-column label="考试时间" prop="reportTime" show-overflow-tooltip width="320">
            <template slot-scope="scope">
              {{ scope.row | dateFilter }}
            </template>
          </el-table-column>
          <el-table-column label="是否补考" prop="makeUpExam" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.makeUpExam | isMakeUpExam }}
            </template>
          </el-table-column>
          <el-table-column
            label="考试总时长"
            prop="totalExamDuration"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="考试状态"
            prop="examStatusStr"
            min-width="120"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              <span v-if="nowTime < dayjs(scope.row.singleExamStartTime)">待开始</span>
              <span
                v-if="
                  dayjs(scope.row.singleExamStartTime) < nowTime &&
                    nowTime < dayjs(scope.row.singleExamEndTime)
                "
                >进行中</span
              >
              <span v-if="nowTime > dayjs(scope.row.singleExamEndTime)">已完成</span>
            </template> -->
          </el-table-column>
          <el-table-column
            label="发起人"
            prop="sponsorName"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="考试公告"
            prop="examNotice"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column label="操作" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="
                  !($hasAccess('read') || (scope.row.sponsor && scope.row.sponsor.includes(userId)))
                "
                >查看</el-button
              >
              <!-- 2已完成不在考试时间过去页面会报错；不在考试时间禁用按钮，状态等后台修改 -->
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'startExam')"
                :disabled="
                  !(
                    $hasAccess('startExam') &&
                    scope.row.examStatus !== 2 &&
                    scope.row.examStatus !== 4 &&
                    dayjs(scope.row.singleExamStartTime) < nowTime &&
                    nowTime < dayjs(scope.row.singleExamEndTime)
                  )
                "
                >开始考试</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>

    <QuestionTaskForm
      v-if="formDialog"
      :pageType="formProps.editType"
      :operateData="FormData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    />
  </el-card>
</template>

<script>
import { ExamTaskApi, OnlineExamsApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import QuestionTaskForm from '../components/QuestionTask/QuestionTaskForm'

const examTaskApi = new ExamTaskApi()
const onlineExamsApi = new OnlineExamsApi()

export default {
  name: 'question-task',
  components: {
    QuestionTaskForm,
  },
  filters: {
    dateFilter(row) {
      if (row.singleExamStartTime && row.singleExamEndTime) {
        return `
          ${dayjs(row.singleExamStartTime).format('YYYY-MM-DD HH:mm:ss')} -
          ${dayjs(row.singleExamEndTime).format('YYYY-MM-DD HH:mm:ss')}
        `
      }
      return ''
    },
    isMakeUpExam(value) {
      if (value === true) {
        return '是'
      }
      if (value === false) {
        return '否'
      }
      return ''
    },
  },
  data() {
    return {
      nowTime: dayjs(),
      hiddenTypeList: [],
      ownedSystemOrUnitList: [],
      makeUpExamList: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],

      FormData: {},
      formDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增考试任务',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {},
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
      timer: null,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    userId() {
      // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      return sub
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  activated() {
    if (this.timer) return
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 1000)
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  created() {
    if (this.$route.query.id && this.$route.query.mode) {
      this.waitResolve(this.$route.query.id, this.$route.query.mode)
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      ['hiddenTypeList', 'ownedSystemOrUnitList'],
      this
    )
    this.searchList()
    if (this.timer) return
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 5000)
  },

  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.acceptanceTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.acceptanceTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.acceptanceTimeStart = ''
        this.searchData.acceptanceTimeEnd = ''
      }
    },
  },
  methods: {
    // 待办处理
    async waitResolve(id, mode) {
      if (mode !== 'read') {
        const [err, res] = await examTaskApi.get(id, { id })
        if (!err) {
          if (
            res.examStatus === 2 ||
            res.examStatus === 4 ||
            (dayjs(res.singleExamStartTime) < this.nowTime &&
              this.nowTime < dayjs(res.singleExamEndTime))
          ) {
            this.$message.warning('考试时间未到或考试已结束，无法开始考试')
            return
          }
          // 没有新增获取数据
          this.handleEvent({ id }, 'startExam')
        }
      } else {
        this.initDialog({ id }, 'read')
      }
    },
    handleCancel() {
      this.formDialog = false
      if (this.$route.query.id) {
        this.$router.replace(this.$route.path)
        this.$router.go(-1)
      }
    },
    refreshList() {
      if (this.$route.query.id) {
        this.$router.replace(this.$route.path)
        this.$router.go(-1)
      }
      this.formDialog = false
      this.findList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      this.loading = true
      const [err, res] = await examTaskApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 列表操作-事件
    async handleEvent(row = {}, operation) {
      switch (operation) {
        case 'startExam':
          const [err, res] = await onlineExamsApi.startExam({ body: { examTaskId: row.id } })
          if (!err) {
            this.$router.push({
              path: 'online-question',
              query: {
                id: row.id,
                isNeedReplaceRoute: this.$route.query.id && this.$route.query.mode ? '1' : '0',
              },
            })
          }
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        default:
          break
      }
    },

    async initDialog(row, operation) {
      const [err, res] = await examTaskApi.get(row.id, { id: row.id })
      if (!err) {
        // 没有新增获取数据
        this.formProps.editType = operation
        this.FormData = res
        this.formDialog = true
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
